/**
 * Sidebar contextual del módulo Smarty Ads — patrón Chatwoot/Linear.
 *
 * En cualquier ruta `/ads/*` reemplaza al Sidebar global (lo decide
 * `AppLayout`). Polaris `<Navigation>` + `<Navigation.Section>`, con
 * "Volver" para salir del módulo. Réplica EXACTA del patrón de
 * `CallCenterNavigation` / `WaInboxNavigation` (módulo-as-app, Polaris —
 * NO un sidebar custom).
 */

import { useLocation } from 'react-router-dom';
import { Navigation } from '@/lib/polaris';
import {
  ArrowLeftIcon,
  ChartVerticalFilledIcon,
  MagicIcon,
  StarFilledIcon,
  ImageIcon,
  PersonIcon,
  LinkIcon,
  SettingsIcon,
  ChatIcon,
  EditIcon,
} from '@/lib/polaris-icons';
import { ROUTES, storePath } from '@/config/routes.config';
import { useAuth } from '@smarty/shared';

export function AdsNavigation() {
  const location = useLocation();
  const { storeSlug } = useAuth();

  const toUrl = (route: string) =>
    storeSlug ? storePath(storeSlug, route) : route;

  const path = location.pathname || '';

  const ALL = [
    ROUTES.ADS,
    ROUTES.ADS_CHAT,
    ROUTES.ADS_STRATEGIES,
    ROUTES.ADS_STRATEGIES_SAVED,
    ROUTES.ADS_CONTENT,
    ROUTES.ADS_TESTIMONIALS,
    ROUTES.ADS_ONBOARDING,
    ROUTES.ADS_ONBOARDING_CONVERSATIONAL,
    ROUTES.ADS_CONNECT,
    ROUTES.ADS_SETTINGS,
  ];
  let activeUrl = '';
  for (const r of ALL) {
    const full = toUrl(r);
    if (
      (path === full || path.startsWith(full + '/')) &&
      full.length > activeUrl.length
    ) {
      activeUrl = full;
    }
  }
  const mk = (route: string, label: string, icon: typeof MagicIcon, badge?: string) => {
    const url = toUrl(route);
    return { url, label, icon, matches: url === activeUrl, ...(badge ? { badge } : {}) };
  };

  const adsItems = [
    mk(ROUTES.ADS, 'Campañas', ChartVerticalFilledIcon),
    mk(ROUTES.ADS_CHAT, 'Chat senior IA', ChatIcon, 'Beta'),
  ];

  const growthItems = [
    mk(ROUTES.ADS_STRATEGIES, 'Crear estrategia', MagicIcon),
    mk(ROUTES.ADS_STRATEGIES_SAVED, 'Estrategias guardadas', StarFilledIcon),
    mk(ROUTES.ADS_CONTENT, 'Creativos', ImageIcon),
    mk(ROUTES.ADS_TESTIMONIALS, 'Testimonios', PersonIcon),
  ];

  const accountItems = [
    mk(ROUTES.ADS_ONBOARDING_CONVERSATIONAL, 'Onboarding con IA', ChatIcon, 'Nuevo'),
    mk(ROUTES.ADS_ONBOARDING, 'Perfil del negocio (form)', EditIcon),
    mk(ROUTES.ADS_CONNECT, 'Conectar cuenta Meta', LinkIcon),
    mk(ROUTES.ADS_SETTINGS, 'Configuración', SettingsIcon),
  ];

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        minHeight: 0,
      }}
    >
      <div style={{ flex: 1, minHeight: 0, overflow: 'auto' }}>
        <Navigation location={location.pathname}>
          <Navigation.Section
            items={[
              {
                label: 'Volver',
                icon: ArrowLeftIcon,
                url: toUrl(ROUTES.HOME),
                matches: false,
              },
            ]}
          />
          <Navigation.Section title="Smarty Ads" items={adsItems} separator />
          <Navigation.Section title="Crecimiento" items={growthItems} separator />
          <Navigation.Section title="Cuenta" items={accountItems} separator />
        </Navigation>
      </div>
    </div>
  );
}
